import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActualsListingInfo {
  budgetYear: string;
}

const initialState: ActualsListingInfo = {
  budgetYear: "",
};

const createActualsListingSlice = createSlice({
  name: "actualsListing",
  initialState,
  reducers: {
    setCreateActualsListing: (
      state,
      action: PayloadAction<Partial<ActualsListingInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeActualsListing: () => initialState,
  },
});

export const { setCreateActualsListing, removeActualsListing } =
  createActualsListingSlice.actions;
export default createActualsListingSlice.reducer;
